/**
 * The Staff screen's URL view state and sort columns (DNKADM-0430 P1-F).
 *
 * URL params on `/staff` (all optional; a default is never written):
 * - `q`: search on the staff name and email.
 * - `status`: the Active/Inactive/All filter (default `active`).
 * - `sort` + `dir`: the column sort. The server sends staff in no defined order, so the
 *   default is Name ascending. Locations (a list per row) is not sortable.
 */
import { staffDisplayName, type V2Staff } from '@/api/staff';
import { matchesSearch } from '@/components/list/listSearch';
import type { SortState, SortValue } from '@/components/list/listSort';

export const STAFF_URL_DEFAULTS = { q: '', status: 'active', sort: '', dir: '' };

export type StaffSortKey = 'name' | 'email' | 'status';
export const STAFF_SORT_KEYS: readonly StaffSortKey[] = ['name', 'email', 'status'];
export const STAFF_DEFAULT_SORT: SortState<StaffSortKey> = { key: 'name', dir: 'asc' };

/** What a staff row shows (and sorts by); no email sorts last. */
export function staffSortValue(member: V2Staff, key: StaffSortKey): SortValue {
  switch (key) {
    case 'name':
      return staffDisplayName(member);
    case 'email':
      return member.email;
    case 'status':
      return member.isActive ? 'Active' : 'Inactive';
  }
}

/** The Staff search: the name or the email. */
export function staffMatches(member: V2Staff, query: string): boolean {
  return matchesSearch(query, [staffDisplayName(member), member.email]);
}
